import { render } from "./NewOffer.vue?vue&type=template&id=13b70704&scoped=true"
import script from "./NewOffer.vue?vue&type=script&lang=js"
export * from "./NewOffer.vue?vue&type=script&lang=js"

import "./NewOffer.vue?vue&type=style&index=0&id=13b70704&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b70704"]])

export default __exports__